module.exports = __webpack_public_path__ + "static/img/cj09.5de166b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/cj09.png
// module id = 152
// module chunks = 0